<template>
  <div>
    <div class="row">
      <div class="col-6">
        <h2>Sound Files</h2>
        <button type="button" class="btn btn-primary" @click="showUploadModal">Upload new sound</button> 
      </div>
      <div class="col-6 text-right">
        <div class="d-flex align-items-end mb-1">
          <label class="w-25 text-right">Search:&nbsp;</label>
          <div class="w-75">
            <input 
              class="w-100 form-control"
              style="border-radius: 4px"
              v-model="query_text"
              maxlength="100"
              placeholder="Search for file by name"
            />
          </div>
        </div>
        <div class="d-flex align-items-end my-1">
          <label class="w-25 text-right">Tags:&nbsp;</label>
          <div class="w-75">
            <v-select
              multiple
              v-model="selected_tags"
              :options="['alert', 'announcement', 'bell', 'playlist']"
              placeholder="Showing All"
            ></v-select>
          </div>
        </div>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-12">
        <table class="table table-striped">
          <thead class="bg-hub-primary text-white">
          <tr>
            <th>File</th>
            <th>Tags</th>
            <th>Manage</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="sound in filtered_sounds" :key="sound.sound_id">
            <td>
              <a-player narrow :music="{
                title: sound.filename,
                author: sound.filename,
                url: '/upload/sounds/' + sound.site_id + '/' + sound.filename,
                pic: './static/images/sound_file_image.png'
              }"></a-player>
              <span>{{ sound.filename }}</span>
            </td>
            <td>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" :id="'cbAlert' + sound.sound_id" v-model="sound.alert" @change="setTags(sound)">
                <label class="form-check-label" :for="'cbAlert' + sound.sound_id">Alert</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" :id="'cbAnnouncement' + sound.sound_id" v-model="sound.announcement" @change="setTags(sound)">
                <label class="form-check-label" :for="'cbAnnouncement' + sound.sound_id">Announcement</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" :id="'cbBell' + sound.sound_id" v-model="sound.bell" @change="setTags(sound)">
                <label class="form-check-label" :for="'cbBell' + sound.sound_id">Bell</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" :id="'cbPlaylist' + sound.sound_id" v-model="sound.playlist" @change="setTags(sound)">
                <label class="form-check-label" :for="'cbPlaylist' + sound.sound_id">Playlist</label>
              </div>
            </td>
            <td>
              <button type="button" class="btn btn-danger" @click="deleteSound(sound)"><i
                class="fa fa-trash fa-fw" aria-hidden="true"></i></button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <Modal modal_id="soundUploadModal" size="md">
      <template #title>Upload sound</template>
      <template #body>
        <form enctype="multipart/form-data">
          <div class="d-flex flex-column">
            <div class="input-group mb-3">
              <div class="custom-file">
                <input type="file" class="custom-file-input" accept=".mp3,.wav" @change="processFile($event)">
                <label class="custom-file-label">{{ file_name }}</label>
              </div>
            </div>
            <div class="d-flex">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="cbAlert" v-model="tags.alert">
                <label class="form-check-label" for="cbAlert">Alert</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="cbAnnouncement" v-model="tags.announcement">
                <label class="form-check-label" for="cbAnnouncement">Announcement</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="cbBell" v-model="tags.bell">
                <label class="form-check-label" for="cbBell">Bell</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="cbPlaylist" v-model="tags.playlist">
                <label class="form-check-label" for="cbPlaylist">Playlist</label>
              </div>
              <button type="button" class="btn btn-secondary ml-auto" @click="upload()">Upload</button>
            </div>
          </div>
        </form>
      </template>
    </Modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueAplayer from '../vue-aplayer'
import 'aplayer/dist/APlayer.min.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import Modal from '../../../components/Modal'

export default {
  data: function () {
    return {
      file_name: '',
      file: '',
      tags: {
        alert: true,
        announcement: true,
        bell: true,
        playlist: true
      },
      query_text: '',
      selected_tags: []
    }
  },
  computed: {
    ...mapGetters({
      sounds: 'allSounds',
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_sounds: function () {
      const queryText = this.query_text.trim().toLowerCase()
      return this.sounds.filter(sound => {
        let include = this.selected_tags.length === 0 || sound.tags.split(',').some(tag => this.selected_tags.includes(tag))
        if(include && queryText !== '' && !sound.filename.toLowerCase().includes(queryText)) {
          include = false
        }
        return sound.site_id === this.scoped_site_id && include
      })
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', false)
    this.$store.dispatch('getSounds')
  },
  components: {
    'a-player': VueAplayer, vSelect, Modal
  },
  methods: {
    ...mapActions([
      'setTags'
    ]),
    showUploadModal() {
      $('#soundUploadModal').modal('show') // eslint-disable-line
    },
    processFile (event) {
      this.file_name = event.target.files[0].name
      this.file = event.target.files[0]
    },
    upload () {
      alert('Please be aware, it may take a few seconds to upload the file.')
      let data = {
        file: this.file,
        tags: this.tags
      }
      this.$store.dispatch('uploadSoundFile', data)
      $('#soundUploadModal').modal('hide') // eslint-disable-line

    },
    deleteSound (sound) {
      this.$store.dispatch('deleteSoundFile', sound)
    }
  }
}
</script>
